import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export type ModalSize = 'sm' | 'md' | 'lg' | 'xl';

const SIZE_CLASSES: Record<ModalSize, string> = {
  sm: 'max-w-md',
  md: 'max-w-xl',
  lg: 'max-w-3xl',
  xl: 'max-w-5xl',
};

interface ModalProps {
  title: React.ReactNode;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: ModalSize;
}

export const Modal: React.FC<ModalProps> = ({ title, onClose, children, footer, size = 'md' }) => (
  <div className="fixed inset-0 bg-slate-900/50 flex items-center justify-center z-50 p-4">
    <div className={`bg-white rounded-lg shadow-xl w-full ${SIZE_CLASSES[size]} max-h-[90vh] flex flex-col`}>
      <div className="flex justify-between items-center px-6 py-4 border-b border-slate-200 flex-shrink-0">
        <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
        <button
          type="button"
          onClick={onClose}
          aria-label="Cerrar"
          title="Cerrar"
          className="text-slate-400 hover:text-slate-600 rounded-md p-1 hover:bg-slate-100"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
      <div className="px-6 py-4 overflow-y-auto">{children}</div>
      {footer && <div className="px-6 py-4 border-t border-slate-200 flex-shrink-0">{footer}</div>}
    </div>
  </div>
);

export default Modal;
